function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.02586 10.5509H6.87931V8.62122H11.7931V9.51184L9.33621 15.3009H8.02586L10.4828 9.51184H8.02586V10.5509Z",
  fill: "current"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.1552 2.98059C10.1552 3.30851 9.86186 3.57434 9.50002 3.57434C9.13818 3.57434 8.84485 3.30851 8.84485 2.98059V0.605591C8.84485 0.277672 9.13818 0.0118408 9.50002 0.0118408C9.86186 0.0118408 10.1552 0.277672 10.1552 0.605591V2.98059Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5838 2.98059C15.5838 3.30851 15.2904 3.57434 14.9286 3.57434C14.5668 3.57434 14.2734 3.30851 14.2734 2.98059V0.605591C14.2734 0.277672 14.5668 0.0118408 14.9286 0.0118408C15.2904 0.0118408 15.5838 0.277672 15.5838 0.605591V2.98059Z",
  fill: "current"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.72662 2.98059C4.72662 3.30851 4.43329 3.57434 4.07145 3.57434C3.70961 3.57434 3.41628 3.30851 3.41628 2.98059V0.605591C3.41628 0.277672 3.70961 0.0118408 4.07145 0.0118408C4.43329 0.0118408 4.72662 0.277672 4.72662 0.605591V2.98059Z",
  fill: "current"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.87931 10.5509H8.02586V9.51184H10.4828L8.02586 15.3009H9.33621L11.7931 9.51184V8.62122H6.87931V10.5509Z",
  fill: "current"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 16.6368V4.16809C19 2.85641 17.8267 1.79309 16.3793 1.79309L16.0049 1.7931V2.9806C16.0049 3.51933 15.523 3.95605 14.9286 3.95605C14.3341 3.95605 13.8522 3.51933 13.8522 2.9806V1.7931L10.5764 1.7931V2.9806C10.5764 3.51933 10.0945 3.95605 9.50001 3.95605C8.90555 3.95605 8.42365 3.51933 8.42365 2.9806V1.7931H5.14781V2.9806C5.14781 3.51933 4.6659 3.95605 4.07144 3.95605C3.47698 3.95605 2.99507 3.51933 2.99507 2.9806V1.7931L2.62069 1.79309C1.17332 1.79309 0 2.85641 0 4.16809V16.6368C0 17.9485 1.17332 19.0118 2.62069 19.0118H16.3793C17.8267 19.0118 19 17.9485 19 16.6368ZM0.982756 4.76184V16.6368C0.982756 17.4566 1.71608 18.1212 2.62069 18.1212H16.3793C17.2839 18.1212 18.0172 17.4566 18.0172 16.6368V4.76184H0.982756ZM6.87931 10.5509H8.02586V9.51184H10.4828L8.02586 15.3009H9.33621L11.7931 9.51184V8.62122H6.87931V10.5509Z",
  fill: "current"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default __webpack_public_path__ + "static/media/participate.14924b61.svg";
export { SvgComponent as ReactComponent };